import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/client/prompter/PrompterDynamicPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/common/PageLoader.tsx");
